<template>
  <div class="container">
    <h4 class="cardD">Cita para firma</h4>
    <!-- <card class="blue">
      <i class="fa fa-info"></i>
      En este espacio debe colocar el link de la cita creada en Calendly.
      <p></p>
    </card> -->

    <div>
      <ValidationProvider name="fecha_firma" rules="required" v-slot="{ errors }" :custom-messages="{
        required: 'El link es obligatorio'
      }">
        <b-form-group label="Link cita Calendly" label-for="input-link-cita">
          <b-input-group class="mt-3">
            <b-input-group-append>
              <b-button :variant="isTextCopied ? 'success' : 'secondary'" squared
                v-b-tooltip.hover title="Copiar" @click="copyLinkToClipboard">
                <b-icon v-if="isTextCopied" icon="check"></b-icon>
                <b-icon v-else icon="clipboard"></b-icon>
              </b-button>
            </b-input-group-append>
            <b-form-input id="input-link-cita" type="link" v-model="formalizacion.link_calendario"
              placeholder="Link Calendly"></b-form-input>
          </b-input-group>
        </b-form-group>
        <!-- <base-input type="text" label="Link cita Calendly" placeholder="Link Calendly"
          v-model="formalizacion.link_calendario">
        </base-input> -->
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div v-if="!formalizacion.firma_fuera_oficina" class="mt-3">
      <ValidationProvider name="direccion_firma" rules="required" v-slot="{ errors }" :custom-messages="{
        required: 'La dirección es obligatoria'
      }">
        <base-input type="text" label="Dirección" placeholder="Dirección donde será la firma"
          v-model="formalizacion.direccion_firma">
        </base-input>
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m">Enviar a cliente</b-button>
      </div>
    </div>

    <div class="row mt-4 fecha">
      <div class="col-3">
        <label class="">Fecha seleccionada</label>
      </div>
      <div class="col-9">
        {{ fecha_formatted }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabCitaFirma",

  props: {
    formalizacion: { type: Object }
  },

  created() {
    let date = new Date(this.formalizacion.fecha_firma);
    let hour = this.formalizacion.fecha_firma.substring(11, 16);
    this.fecha_formatted = date.toLocaleDateString();
    this.fecha_formatted += " ";
    this.fecha_formatted += hour;
  },

  data: () => ({
    isTextCopied: false,
    fecha_formatted: null
  }),

  methods: {
    copyLinkToClipboard() {
      if (!this.formalizacion.link_calendario) {
        return;
      }

      navigator.clipboard
        .writeText(this.formalizacion.link_calendario)
        .then(this.isTextCopied = true);
    },

    validar() {
      this.$emit("validaForm", "CitaFirma");
    }
  }
};
</script>

<style scoped>
.datePicker {
  text-transform: lowercase !important;
  /* color: #79cff7; */
}

.datePicker:first-letter {
  text-transform: capitalize !important;
}

.fecha {
  margin-top: 60px !important;
}
</style>
